import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, ProgressBar, Button, Tab, Tabs, Dropdown } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";

import Docmnt from '../../../../assets/images/google-docs.png';
import Cargoplane from "../../../../assets/images/plane.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Cuser from "../../../../assets/images/cuser.png";
import Rapdf from "../../../../assets/images/pdf.png";
import tick from "../../../../assets/images/tick.png";
import cross from "../../../../assets/images/white-cross.png";
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';


import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const OrdersView = ({ applyFilter, filterData, setApplyFilter, resetGrid }) => {
    const history = useHistory();
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [disLoading, setDisLoading] = useState(false);
    const user = localStorage.getItem('RFS');
    const [filterApplied, setFilterApplied] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [gridData, setGridData] = useState([]);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    // const gridRef = useRef(null);
    const orderTypeTab = localStorage.getItem("orderTypeTab");
    const [activeTab, setActiveTab] = useState(orderTypeTab || 'All');
    const gridRef = {
        All: useRef(null),
        Active: useRef(null),
        Archived: useRef(null),
    };
    const handleTabChange = async (tab) => {
        console.log("🚀 ~ handleTabChange ~ tab:", tab)
        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        if (tab == 'All') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ All: {} });
            }, 1);
        } else if (tab == 'Loading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Loading: {} });
            }, 1);
        } else if (tab == 'Unloading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Unloading: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archive: {} });
            }, 1);
        }
    };

    useEffect(() => {
        const orderTypeTab = localStorage.getItem("orderTypeTab");
        // console.log("asasdasd",orderTypeTab)
        if (orderTypeTab) {
            (async () => {
                await handleTabChange(orderTypeTab);
            })();
        }
    }, []);

    useEffect(() => {
        if (applyFilter && gridRef.current) {
            // window.$(gridRef[activeTab]?.current).jqxGrid("clearfilters");
            // window.$(gridRef[activeTab]?.current).jqxGrid("updatebounddata", "filter");
            Object.keys(filterData).forEach((field) => {
                const filterValue = filterData[field];
                if (filterValue !== null && filterValue !== undefined) {
                    const filterGroup = new window.$.jqx.filter();
                    const filterCondition = "CONTAINS"; // Adjust the condition as needed
                    const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
                    filterGroup.addfilter(1, filter);
                    window.$(gridRef[activeTab]?.current).jqxGrid("addfilter", field, filterGroup);
                }
            });
            window.$(gridRef[activeTab]?.current).jqxGrid("applyfilters");
            setApplyFilter(false); // Reset the applyFilter flag
        }
    }, [applyFilter, filterData, setApplyFilter]);

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {

        if (gridRef[activeTab]?.current) {
            // if (gridData) {
            // const localData = gridData[activeTab].map(item => ({

            //     id: item.id,
            //     STN: item.station_code,
            //     Taddrs: item.station_addresses.length,
            //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
            // }));
            const endPoint = localStorage.getItem('RFS') ? 'airline-order-view-list' : 'monitor/order-view-list'
            let tabType = '';
            let orderType = '';
            switch (activeTab) {
                case 'Active':
                    tabType = 'All';
                    orderType = 'A';
                    break;
                case 'Archived':
                    tabType = 'All';
                    orderType = 'I';
                    break;
                default:
                    tabType = 'All';
                    orderType = 'All';
                    break;
            }
            // var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || '');
            jqxCookieCall()
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}${endPoint}?tab_name=${tabType}&activity_status=${orderType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'order_id', type: 'string' },
                    { name: 'order_number', type: 'string' },
                    { name: 'truck_number', type: 'string' },
                    { name: 'pick_status', type: 'string' },
                    { name: 'loading_advice', type: 'string' },
                    { name: 'carrier_name', type: 'string' },
                    { name: 'trucker_name', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'loading_station', type: 'string' },
                    { name: 'loading_name', type: 'string' },
                    { name: 'loading_location', type: 'string' },
                    { name: 'unloading_station', type: 'string' },
                    { name: 'unloading_name', type: 'string' },
                    { name: 'unloading_location', type: 'string' },
                    { name: 'loading_date_planned', type: 'string' },
                    { name: 'unloading_date_planned', type: 'string' },
                    { name: 'truck_date', type: 'date' },
                    { name: 'planned_time', type: 'date' },
                    { name: 'trip_no', type: 'string' },
                    { name: 'airline_plan', type: 'string' },
                    { name: 'trucker_plan', type: 'string' },
                    { name: 'trip_status', type: 'string' },
                    { name: 'loading_date', type: 'string' },
                    { name: 'unloading_date', type: 'string' },
                ],
                // localdata: gridData,
                filter: function (allfilters) {
                    window.$(gridRef[activeTab]?.current).jqxGrid('clearselection');
                    setGridSelect([]);

                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef[activeTab]?.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRef[activeTab]?.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // let columns = [];

            const columns = [
                ...(!user
                    ? [{ text: 'Trip No.', filtertype: 'textbox', datafield: 'trip_no', width: '10%', cellclassname: '', },
                    { text: 'Order No.', datafield: 'order_number', width: '9%' },]
                    : []
                ),

                { text: 'Truck No.', datafield: 'truck_number', width: '7%' },
                {
                    text: 'Truck Date', datafield: 'truck_date', width: '10%', cellsformat: 'dd-MM-yyyy', filtertype: 'range', filtermode: 'range',
                    // cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    //     if (!cellValue) return "";
                    //     const dateObj = new Date(cellValue + 'Z');
                    //     const formattedDate = dateObj.toISOString().slice(0, 16).replace("T", " ");
                    //     return '<div class="jqx-grid-cell-left-align set_datetime" id=' + dataField + '>' + formattedDate + '</div>';
                    // },
                },

                ...(!user
                    ? [{
                        text: 'Pickup Status', datafield: 'pick_status', width: '11%', filterable: false,
                        cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                            if (value && Array.isArray(value)) {
                                // Generate multiple divs for each item in the array
                                const content = value
                                    .map((item) =>
                                        `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                    ).join(''); // Combine all divs into a single string

                                return `<div class="stats_view">${content}</div>`;
                            }
                            // Fallback if value is not an array or empty
                            return defaulthtml;
                        }
                    },]
                    : [{
                        text: 'Airline Planning', datafield: 'airline_plan', width: '7%',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue == 1) {
                                defaultHtml = `<div class="jqx-grid-cell-left-align" style="padding: 3px;border-radius: 5px;background: #83cd88;color: #FFF !important;border: 1px solid #83cd88 !important;margin-top: 8px;width: 70px;text-align: center;"><img style='padding-right: 3px;width: 18px;' src='${tick}'/> Yes</div>`;
                            } else {
                                defaultHtml = `<div class="jqx-grid-cell-left-align" style="padding: 3px;border-radius: 5px;background: #d15c5e;color: #FFF !important;border: 1px solid #d15c5e !important;margin-top: 8px;width: 70px;text-align: center;"><img style='padding-right: 3px;width: 18px;' src='${cross}'/> No</div>`;
                            }
                            return defaultHtml;
                        },
                    },
                    {
                        text: 'Trucker Planning', datafield: 'trucker_plan', width: '7%',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue == 1) {
                                defaultHtml = `<div class="jqx-grid-cell-left-align" style="padding: 3px;border-radius: 5px;background: #83cd88;color: #FFF !important;border: 1px solid #2fc93b !important;margin-top: 8px;width: 70px;text-align: center;"><img style='padding-right: 3px;width: 18px;' src='${tick}'/> Yes</div>`;
                            } else {
                                defaultHtml = `<div class="jqx-grid-cell-left-align" style="padding: 3px;border-radius: 5px;background: #d15c5e;color: #FFF !important;border: 1px solid #d15c5e !important;margin-top: 8px;width: 70px;text-align: center;"><img style='padding-right: 3px;width: 18px;' src='${cross}'/> No</div>`;
                            }
                            return defaultHtml;
                        },
                    },
                        // {
                        //     text: 'Trip Status', datafield: 'trip_status', width: '10%',
                        //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        //         return '';
                        //     },
                        // },
                    ]
                ),

                {
                    text: 'Loading Advice', datafield: 'loading_advice', width: '10%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                // { text: 'Carrier Name', datafield: 'carrier_name', width: '9%' },
                ...( // Add this column only if the condition is met
                    !user
                        ? [{ text: 'Carrier Name', datafield: 'carrier_name', width: '9%' }]
                        : [{ text: 'Trucker Name', datafield: 'trucker_name', width: '9%' }]
                ),
                // { text: 'Flight No.', datafield: 'flight_number', width: '8%' },
                ...(!user ?
                    [
                        { text: 'Loading Date', cellsformat: 'dd-MM-yyyy', datafield: 'loading_date_planned', width: '9%', cellsformat: 'dd-MM-yyyy', filtertype: 'range', filtermode: 'range', },
                        { text: 'Loading Station', datafield: 'loading_station', width: '8%' },
                        // { text: 'Loading Location', datafield: 'loading_name', width: '9%' },
                        { text: 'Unloading Date', cellsformat: 'dd-MM-yyyy', datafield: 'unloading_date_planned', width: '9%', cellsformat: 'dd-MM-yyyy', filtertype: 'range', filtermode: 'range', },
                        { text: 'Unloading Station', datafield: 'unloading_station', width: '8%' },
                    ] :
                    [
                        { text: 'Boardpoint', datafield: 'loading_station', width: '6%' },
                        { text: 'STD', cellsformat: 'dd-MM-yyyy', datafield: 'loading_date', width: '9%', cellsformat: 'dd-MM-yyyy', filtertype: 'range', filtermode: 'range', },
                        { text: 'Offpoint', datafield: 'unloading_station', width: '6%' },
                        { text: 'STA', cellsformat: 'dd-MM-yyyy', datafield: 'unloading_date', width: '9%', cellsformat: 'dd-MM-yyyy', filtertype: 'range', filtermode: 'range', },

                    ]),
                ...(!user ?
                    [{ text: 'Unloading Location', datafield: 'unloading_name', width: '10%' },
                    { text: 'Planned Time', datafield: 'planned_time', width: '10%' },] : []
                )
                // { text: 'Order No.', datafield: 'order_no', width: '9%' },
            ];

            // Nested ULD Start
            const nestedColumns = [
                { text: 'AWB no', datafield: 'airway_bill', width: '8%' },
                // {
                //     text: 'Pickup Status', datafield: 'pick_status', width: '10%',
                //     cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                //         if (value && Array.isArray(value)) {
                //             // Generate multiple divs for each item in the array
                //             const content = value
                //                 .map((item) =>
                //                     `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                //                 ).join(''); // Combine all divs into a single string

                //             return `<div class="stats_view">${content}</div>`;
                //         }
                //         // Fallback if value is not an array or empty
                //         return defaulthtml;
                //     }
                // },
                { text: 'Pcs', datafield: 'pieces', width: '5%' },
                { text: 'Planned', datafield: 'planned', width: '5%' },
                { text: 'Received (Loading)', datafield: 'received_loading', width: '12%' },
                // { text: 'RCF', datafield: 'rcf', width: '5%' },
                { text: 'MAN', datafield: 'man', width: '5%' },
                { text: 'Received (Unloading)', datafield: 'received_unloading', width: '12%' },
                // { text: 'MSCA', datafield: 'msca', width: '5%' },
                // { text: 'Package', datafield: 'package', width: '8%' },
                { text: 'ULD No.', datafield: 'uld_number', width: '8%' },
                { text: 'Weight', datafield: 'weight', width: '8%' },
                { text: 'Volume', datafield: 'volume', width: '8%' },
                // { text: 'LM', datafield: 'lm', width: '8%' },
                // { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },

            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                // console.log(dataAdapter);
                const id = record.uid.toString();
                const rId = dataAdapter.loadedData.Rows[id]
                // console.log('ov >>:', dataAdapter.loadedData.Rows[id]);
                const uldGrid = dataAdapter.loadedData.Rows[id].awb;

                let nestedSource = {};
                if (!user) {
                    nestedSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: [
                            { name: 'id', type: 'string' },
                            { name: 'airway_bill', type: 'string' },
                            { name: 'pick_status', type: 'string' },
                            { name: 'pieces', type: 'string' },
                            { name: 'rcf', type: 'string' },
                            { name: 'man', type: 'string' },
                            { name: 'msca', type: 'string' },
                            { name: 'package', type: 'string' },
                            { name: 'uld_number', type: 'string' },
                            { name: 'weight', type: 'string' },
                            { name: 'volume', type: 'string' },
                            { name: 'lm', type: 'string' },
                            { name: 'nature_of_goods', type: 'string' },
                        ],
                        localdata: uldGrid,
                    }
                } else {
                    nestedSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: [
                            { name: 'id', type: 'string' },
                            { name: 'airway_bill', type: 'string' },
                            { name: 'pick_status', type: 'string' },
                            { name: 'pieces', type: 'string' },
                            { name: 'rcf', type: 'string' },
                            { name: 'man', type: 'string' },
                            { name: 'msca', type: 'string' },
                            { name: 'package', type: 'string' },
                            { name: 'uld_number', type: 'string' },
                            { name: 'weight', type: 'string' },
                            { name: 'volume', type: 'string' },
                            { name: 'lm', type: 'string' },
                            { name: 'nature_of_goods', type: 'string' },

                        ],
                        url: `${process.env.REACT_APP_RFS_URL}airline-truck-awbs?id=${rId.id}`,
                        // beforeSend: function (jqXHR) {
                        //     jqXHR.setRequestHeader('Authorization', token);
                        // },
                        root: "Rows",
                    }
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: '', // checkbox
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);


            };
            // Nested End

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox', // checkbox

                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (10 * 45),
                    rowdetailshidden: true,
                },

            };

            window.$(gridRef[activeTab]?.current).jqxGrid(gridOptions);
            window.$(gridRef[activeTab]?.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef[activeTab]?.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef[activeTab]?.current).off('cellclick');
            window.$(gridRef[activeTab]?.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                // console.log('event', args)
                if (event.args.columnindex === 7) {
                    return;
                }
                if (event.args.columnindex > 0) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef[activeTab]?.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    loadDetails(args.id);
                    // setSelectedRowData(args);
                }
            });
            window.$(gridRef[activeTab]?.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.order_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // 
                    // if (!gridSelect.some(row => row.order_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.order_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef[activeTab]?.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef[activeTab]?.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.order_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.order_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
        }
    }, [gridData]);
    const resetFilters = () => {
        window.$(gridRef[activeTab]?.current).jqxGrid('clearfilters');
    };

    useEffect(() => {
        if (resetGrid) {
            // window.$(gridRef[activeTab]?.current).jqxGrid('updatebounddata');
            window.$(gridRef[activeTab]?.current).jqxGrid('clearfilters');
            window.$(gridRef[activeTab]?.current).jqxGrid("updatebounddata", "filter");
        }
    }, [resetGrid])

    const loadDetails = async (id) => {
        setDisLoading(true);
        try {
            const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: id });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                setSelectedRowData(innerData);
                setDisLoading(false);
            } else {
                toast.error('No Details found');
                setDisLoading(false);
            }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const OrderViewDetailsClick = () => {
        try {
            // Check if selectedRowData is defined
            if (!selectedRowData) {
                throw new Error('Selected row data is not available.');
            }

            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD: selectedRowData,  // ULD Details section
                Form: {}  // Empty form section
            };
            localStorage.setItem('OVDetails', JSON.stringify(storageData));
            // localStorage.setItem('tab', 'assets');
            window.location.href = '/TruckMonitor/OrdersViewDetails'
            // window.location.href = '/TruckMonitor/Details'
        } catch (error) {
            // Log the error for debugging purposes
            console.error('Error during navigation:', error.message);
            alert('An error occurred: ' + error.message); // Optional user alert
        }
    }

    const handleCloseClick = () => {
        setSelectedRowData(null);
        window.$(gridRef[activeTab]?.current).jqxGrid("updatebounddata");
    };

    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }

    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END
    const handleMoveTo = async (type) => {
        setConfirmModal(true);
    }
    const handleMove = async (type) => {
        const payload = {
            order_ids: gridSelect.map(item => item.order_id),
            activity_status: type
        };
        try {
            const res = await withRFSToken.post('monitor/update-activity', payload)
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        setIsLoading(false);
                        setConfirmModal(false);
                        setGridSelect([]);
                        window.$(gridRef[activeTab]?.current).jqxGrid('clearselection');
                        window.$(gridRef[activeTab]?.current).jqxGrid('updatebounddata');

                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };
    const confirmModalClose = () => {
        setConfirmModal(false);
    }
    return (
        <>
            {/* {console.log('selectedRowData', selectedRowData)} */}
            <div className="mt-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    {!user &&
                        <>
                            <Dropdown>
                                <Dropdown.Toggle variant="light" id="dropdown-basic" className={gridSelect.length > 0 ? 'action grid-selected' : 'action'}>
                                    <FontAwesomeIcon icon={faGear} /> Action <FontAwesomeIcon icon={faChevronDown} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>

                                    {activeTab === 'All' ? (
                                        <>
                                            <Dropdown.Item onClick={() => handleMoveTo('A')}>Active</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleMoveTo('I')}>Archive</Dropdown.Item>
                                        </>
                                    ) : (
                                        <Dropdown.Item
                                            onClick={() => handleMoveTo(activeTab === 'Archived' ? 'A' : 'I')}
                                        >
                                            {activeTab === 'Archived' ? 'Active' : 'Archive'}
                                        </Dropdown.Item>
                                    )}

                                </Dropdown.Menu>
                            </Dropdown>

                            {/* <button className={'exportbtn me-3 active'} onClick={() => history.push('/OrderDetails')}>
                                <span>Create Order</span>
                            </button> */}
                        </>
                    }
                </div>
                {user &&
                    <div className='ulddown'>
                        {activeTab == 'All' ? (
                            <>
                                <button onClick={() => handleMoveTo('A')}> <img title='' src={Activ} /> Active </button>
                                <button onClick={() => handleMoveTo('I')}> <img title='' src={Arcv} /> Archive </button>
                            </>
                        ) : (
                            <>
                                <button onClick={() => handleMoveTo(activeTab === 'Archived' ? 'A' : 'I')}> <img title='' src={activeTab === 'Archived' ? Activ : Arcv} /> {activeTab === 'Archived' ? 'Active' : 'Archive'} </button>
                            </>
                        )
                        }

                    </div>
                }
            </div>
            <div className="maindiv">
                {disLoading &&
                    <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                }
                {/* <div className='trashdonload'>
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                </div> */}
                <div className='trashdonload'>
                    {/* <button onClick={() => handleMoveTo(activeTab === 'Active' ? 'R' : 'A')}><img src={activeTab === 'Active' ? Arcv : Activ} alt={activeTab} />  Move to {activeTab === 'Active' ? 'Archive' : 'Active'}</button> */}
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="All" title={<span>All </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /> </Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                <div ref={gridRef.All} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRef.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Active" title={<span>Active </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRef.Active} className='bookinggrid' ></div>}
                            {/* <div ref={gridRef.Archived} className='bookinggrid' ></div> */}
                        </Tab>

                        <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRef.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRef.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                    {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.order_number} &nbsp;
                                <span className='position-relative'>
                                    {
                                        selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                                            selectedRowData?.pick_status.map((item) =>
                                                <>
                                                    {/* <div class=""> */}
                                                    <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                    {/* </div> */}
                                                </>
                                            )
                                            : ''
                                    }
                                </span>
                            </h3>
                            <div className='d-flex actbtn justify-content-between'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Button variant="light" onClick={OrderViewDetailsClick} > Details</Button> */}

                                <div className='viwall'>
                                    <Link to='#' onClick={OrderViewDetailsClick} >View Details</Link>
                                </div>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='d-flex justify-content-between my-3'>
                            <div className='order_view'>
                                <h3>{selectedRowData.loading_station}</h3>
                                {/* <span>{selectedRowData.loading_name}</span> */}
                                <span>
                                    {selectedRowData.loading_name && selectedRowData.loading_name.length > 20
                                        ? `${selectedRowData.loading_name.slice(0, 20)}...`
                                        : selectedRowData.loading_name}
                                </span>
                                <div className='mt-3'>
                                    <p>Scheduled - <b>{selectedRowData.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                    <p>Actual - <b>{selectedRowData.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                                </div>
                            </div>
                            <div className='order_middle'>
                                <p><img src={Cargotruck} /></p>
                                <span>{selectedRowData.truck_number}</span>
                            </div>
                            <div className='order_view'>
                                <h3>{selectedRowData.unloading_station}</h3>
                                {/* <span>{selectedRowData.unloading_name}</span> */}
                                <span>
                                    {selectedRowData.unloading_name && selectedRowData.unloading_name.length > 20
                                        ? `${selectedRowData.unloading_name.slice(0, 20)}...`
                                        : selectedRowData.unloading_name}
                                </span>
                                <div className='mt-3'>
                                    <p>Scheduled - <b>{selectedRowData.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                    <p>ETA - <b>{selectedRowData.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                </div>
                            </div>
                        </div>
                        <div className='mb-3'>
                            <ProgressBar animated now={50} style={{ height: "5px" }} />
                        </div>
                        <div className='movment_history'>
                            <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {selectedRowData && selectedRowData?.status_updates.map((history, index) => (
                                    <li>
                                        <span className='movem w-auto'>{history.status}</span>
                                        <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                        {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"rfs_order"}
                            attachable_id={selectedRowData.order_id}
                            attachments={selectedRowData.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData.order_id)}
                        />
                        <ActivityComments
                            commentable_type={"rfs_order"}
                            commentable_id={selectedRowData.order_id}
                            allactivities={selectedRowData.activities}
                            onReloadDetails={() => loadDetails(selectedRowData.order_id)}
                        />
                    </div>
                )}
            </div>
            <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>{activeTab !== 'Active' ? 'Active Truck Orders' : 'Archive Truck Orders'}</h2>
                    <p>
                        {activeTab !== 'Active' ? 'Are you sure you want to active the selected truck orders.' : 'Are you sure you want to archive the selected truck orders.'}
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setConfirmModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => handleMove(activeTab === 'Active' ? 'I' : 'A')}>
                        {activeTab === 'Active' ? 'Archive' : 'Active'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default OrdersView;